import { useEffect, useRef, type ReactNode } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

/** Contenedor de la barra contextual; se cierra al pulsar fuera. */
export function BeatFigureContextZone({ open, onClose, children }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const onDocPointer = (e: PointerEvent) => {
      if (!ref.current?.contains(e.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('pointerdown', onDocPointer);
    return () => document.removeEventListener('pointerdown', onDocPointer);
  }, [open, onClose]);

  return (
    <div
      ref={ref}
      className={`beat-slot__header-zone beat-slot__header-zone--context ${open ? 'beat-slot__header-zone--open' : ''}`}
    >
      {children}
    </div>
  );
}
